(() => {
  if (window.yolaInstagramFeedInitialized) return;
  window.yolaInstagramFeedInitialized = true;
  const init = () => document.querySelectorAll('[data-yi-feed]').forEach(root => {
    if (root.dataset.yiBound) return;
    root.dataset.yiBound = 'true';
    const track = root.querySelector('[data-yi-track]');
    const items = [...track.children];
    const previous = root.querySelector('[data-yi-direction="-1"]');
    const next = root.querySelector('[data-yi-direction="1"]');
    const count = root.querySelector('[data-yi-count]');
    root.querySelector('[data-yi-controls]').hidden = false;
    const sync = () => {
      const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      const rect = track.getBoundingClientRect();
      const visible = items.map((item, i) => ({i, rect:item.getBoundingClientRect()})).filter(item => item.rect.right > rect.left + 12 && item.rect.left < rect.right - 12);
      previous.disabled = track.scrollLeft < 3;
      next.disabled = end;
      if (visible.length) {
        const first = visible[0].i + 1, last = visible[visible.length - 1].i + 1;
        count.textContent = `${first === last ? first : `${first}-${last}`} / ${items.length}`;
      }
    };
    root.querySelector('[data-yi-controls]').addEventListener('click', event => {
      const button = event.target.closest('[data-yi-direction]');
      if (!button) return;
      const step = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
      const visibleCount = Math.max(1, Math.floor((track.clientWidth + 1) / step));
      track.scrollBy({left:Number(button.dataset.yiDirection) * step * visibleCount, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
    let frame;
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }, {passive:true});
    const observer = new ResizeObserver(sync);
    observer.observe(track);
    root.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    sync();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
